<template>
  <div class="program-list-page" v-loading="loading">
    <div class="app-content-create" v-for="tab in Object.values(tabs)" :key="tab.type">
      <el-button
        v-if="hasPermissionToCreate && activeTabIndex === tab.index || isPropertyNBA"
        class="app-content-create-button"
        type="primary"
        @click="handleClickTab(tab)"
      > 
        <app-i18n :code="!isPropertyNBA ? tab.buttonCode : 'entities.season.new.title'"/>
      </el-button>
      <app-empty-page
        v-if="showEmptyPage(tab)"
        :icon-class="'icon-cup'"
        :empty-text="isPropertyNBA ? i18n('entities.season.empty') : tab.empty"
      />
    </div>
    <div class="app-content-page program-list-page__container">
      <app-program-list-toolbar />
      <app-program-list-filter />
      <app-program-list-table v-if="isProgramData"/>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@shared/i18n';

import { ProgramPermissions } from '@modules/program/program-permissions';
import ProgramListFilter from '@modules/program/components/program-list-filter.vue';
import ProgramListTable from '@modules/program/components/program-list-table.vue';
import ProgramListToolbar from '@modules/program/components/program-list-toolbar.vue';
import { getProgramTypeListByPropertyType } from '@shared/factories/enums-factory';
import { get } from 'lodash';
import _ from 'underscore'

export default {
  name: 'app-program-list-page',

  props: {
    type: String
  },

  computed: {
    ...mapGetters({
      rows: 'program/list/rows',
      loading: 'program/list/loading',
      currentManage: 'auth/manage/currentManage',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      currentUser: 'auth/currentUser',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    hasPermissionToCreate() {
      return new ProgramPermissions(this.currentUser)
        .create;
    },
    
    tabs() {
      const propertyType = get(this, 'currentManage.property.type', null);
      const programs = getProgramTypeListByPropertyType(propertyType);
      
      return programs.map((type, keys) => ({
        type,
        label: i18n(`programs.${type}.label`),
        index: keys,
        routerPush: {
          params: {
            type: type
          },
        },
        empty: i18n(`programs.${type}.empty`),
        buttonCode: i18n(`programs.${type}.new`),
      }));
      
    },

    isProgramData() {
      return this.rows.length > 0;
    }, 
  },

  mounted() {
    if (!this.isPropertyNBA) {
      this.setTabs(Object.values(this.tabs));
      var index = this.getIndexByTypeProgram();
      this.setActiveTabIndex(index);
    }
  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
    }),
    handleClickTab(tab) {
      this.setActiveTabIndex(tab.type);
      this.$router.push({
        name: 'programNew',
        params: {
          type: tab.type,
          manage: this.currentManage,
        }
      });
    },

    getIndexByTypeProgram() {
      var index = 0;    

      if (this.type) {
        index = _.indexOf(_.pluck(this.tabs, 'type'), this.type);
      }
      return index;
    },
      
    i18n(code) {
      return i18n(code);
    },

    showEmptyPage(tab) {
      if (this.isPropertyNBA) {
        return !this.isProgramData;
      } else {
        if (this.activeTabIndex === tab.index && !this.isProgramData) {
          return !this.isProgramData;
        }
      }
    }
  },
  components: {
    [ProgramListFilter.name]: ProgramListFilter,
    [ProgramListTable.name]: ProgramListTable,
    [ProgramListToolbar.name]: ProgramListToolbar,
  },
};
</script>
